import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  pdf,
} from '@react-pdf/renderer';
import { registerFont } from '../../../components/MerchantOrderPdf/MerchantOrderPdf';
import { download } from '@/utils/download';
import QRCodeStyling from 'qr-code-styling';

interface QRCode {
  name: string;
  id: string;
}

export const AUTHORIZED_SIGNER_QR_CODE_PREFIX = 'HTTP://VYT.TO/AS/';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    padding: 30,
  },
  qrCodeContainer: {
    width: 175,
    // marginRight: 40, // uncomment for 4 codes per page
  },
  qrCode: {
    width: 175,
    height: 175,
  },
  qrCodeName: {
    textAlign: 'center',
    marginTop: 5,
  },
  qrCodeRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginHorizontal: 45,
    marginVertical: 20,
  },
});

async function getContainerStationQRCode(id: string) {
  const qrCode = getQrCodeStyling(id);
  const blob: any = await qrCode.getRawData('png');
  return window.URL.createObjectURL(blob);
}

function getQrCodeStyling(id: string) {
  return new QRCodeStyling({
    width: 100,
    data: `${AUTHORIZED_SIGNER_QR_CODE_PREFIX}${id}`,
    height: 100,
    dotsOptions: {
      color: '#000000',
      type: 'square',
    },
    imageOptions: {
      crossOrigin: 'anonymous',
      margin: 10,
    },
    backgroundOptions: {
      color: '#00000000',
    },
    qrOptions: {
      errorCorrectionLevel: 'Q',
    },
  });
}

async function authorizedSignerPdf(qrCodes: QRCode[]) {
  const promises = qrCodes.map(async (qrCode, index) => {
    const source = await getContainerStationQRCode(qrCode.id);

    return (
      <View style={styles.qrCodeContainer} key={index}>
        <Image style={styles.qrCode} src={source} />
        <Text style={styles.qrCodeName}>{qrCode.name}</Text>
      </View>
    );
  });

  const qrCodeElements = await Promise.all(promises);

  let pages = [];
  // let rows = [];

  // for (let i = 0; i < qrCodeElements.length; i += 2) { // uncomment for 4 codes per page
  //   rows.push(
  //     <View style={styles.qrCodeRow} key={i}>
  //       {qrCodeElements[i]}
  //       {qrCodeElements[i + 1]}
  //     </View>
  //   );

  //   if ((i + 2) % 4 === 0 || i === qrCodeElements.length - 2) {
  //     pages.push(
  //       <Page size="A4" style={styles.page} key={i}>
  //         {rows}
  //       </Page>
  //     );

  //     rows = [];
  //   }
  // }

  for (let i = 0; i < qrCodeElements.length; i += 1) {
    pages.push(
      <Page size="A4" style={styles.page} key={qrCodeElements.length}>
        <View style={styles.qrCodeRow} key={i}>
          {qrCodeElements[i]}
        </View>
      </Page>,
    );
  }

  return <Document>{pages}</Document>;
}

async function DownloadAuthorizedSignerPdf(
  qrCodes: QRCode[],
  filename: string = 'AuthorizedSigners',
) {
  // process selection before status update since status update resets selection
  registerFont();

  const doc = await authorizedSignerPdf(qrCodes);

  const blob = await pdf(doc).toBlob();

  download(blob, `${filename}_${new Date().toISOString()}.pdf`);
}

export default DownloadAuthorizedSignerPdf;
